(function () {
  let pendingChange = Promise.resolve();
  function getMetadata() {
    const metadata = new Map();
    document.querySelectorAll('[data-cart-line-key]').forEach((row) => {
      const previous = metadata.get(row.dataset.cartLineKey) || {};
      metadata.set(row.dataset.cartLineKey, {
        isGift: previous.isGift || row.dataset.cartIntervalGift === 'true',
        eligible: previous.eligible || row.dataset.giftEligible === 'true',
        giftVariantId: row.dataset.giftVariantId || previous.giftVariantId
      });
    });
    return metadata;
  }

  function removalUpdates(cart, key, metadata = new Map()) {
    const items = cart.items || [];
    const removed = items.find((item) => item.key === key);
    if (!removed) throw new Error('This cart item has changed. Please refresh your cart and try again.');
    const isGift = (item) => {
      const flag = String(item.properties?._cart_interval_gift || '').toLowerCase();
      const labelledGift = metadata.get(item.key)?.isGift ||
        (item.product_title || item.title || '').startsWith('【Free Gift】');
      // A paid purchase of a configured gift product is still a normal item.
      return flag === 'true' || flag === '1' || (item.final_line_price === 0 && labelledGift);
    };
    const updates = { [key]: 0 };
    if (isGift(removed)) return updates;
    const parents = items.filter((item) => !isGift(item));
    const remainingEligible = parents.some((item) => item.key !== key &&
      (!metadata.has(item.key) || metadata.get(item.key)?.eligible));

    items.filter(isGift).forEach((gift) => {
      const parentKey = gift.properties?._cart_gift_parent_key;
      const parentVariant = gift.properties?._cart_gift_parent_variant_id;
      if (parentKey === key) {
        updates[gift.key] = 0;
      } else if (parentKey && !items.some((item) => item.key === parentKey) && parentVariant) {
        // Editing Hulk options changes a line's key. Only use the variant as a
        // fallback when it identifies exactly one parent, never an arbitrary copy.
        const matches = parents.filter((item) => String(item.variant_id) === String(parentVariant));
        if (parents.length === 1 && matches.length === 1 && matches[0].key === key) updates[gift.key] = 0;
      } else if (!parentKey && metadata.get(key)?.giftVariantId === String(gift.variant_id) &&
          !parents.some((item) => item.key !== key && (!metadata.has(item.key) ||
            (metadata.get(item.key)?.eligible && !metadata.get(item.key)?.giftVariantId) ||
            metadata.get(item.key)?.giftVariantId === String(gift.variant_id)))) {
        updates[gift.key] = 0;
      } else if (!parentKey && (parents.length === 1 ||
          (metadata.get(key)?.eligible && !remainingEligible))) {
        // Older promotional gifts have no parent property. Clear them when the
        // last qualifying product is removed, while preserving other parents' gifts.
        updates[gift.key] = 0;
      }
    });
    return updates;
  }

  async function sendQuantityChange({ line, key, quantity, sections, sections_url }) {
    let url = theme.routes.cart_change_url;
    let body = { ...(key ? { id: key } : { line }), quantity, sections, sections_url };
    if (Number(quantity) === 0) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to check associated gifts. Please try again.');
      const cart = await response.json();
      // Use the clicked line's key, not a possibly shifted numeric line index.
      const updates = removalUpdates(cart, key, getMetadata());
      url = theme.routes.cart_update_url.replace(/\.js$/, '') + '.js';
      body = { updates, sections, sections_url };
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function changeQuantity(request) {
    const change = pendingChange.then(() => sendQuantityChange(request));
    pendingChange = change.catch(() => {});
    return change;
  }

  window.CartGiftAssociation = { changeQuantity, removalUpdates };
})();
